// Mock data for Acar Menkul Değerler clone

export const SRETRADE_LOGIN = "https://my.scuzdan.com/login";
export const SRETRADE_REGISTER = "https://my.scuzdan.com/register";
export const ACAR_LOGO_URL = "/logo.png";

export const navMenu = [
  {
    label: "Hakkımızda",
    slug: "/hakkimizda",
    children: [
      { label: "Acar Menkul", slug: "/hakkimizda/acar-menkul" },
      { label: "Vizyon ve Misyonumuz", slug: "/hakkimizda/vizyon-misyon" },
      { label: "Bilgi Almak İstiyorum", slug: "/hakkimizda/bilgi-almak-istiyorum" },
    ],
  },
  {
    label: "Hizmetlerimiz",
    slug: "/hizmetlerimiz",
    children: [
      { label: "Pay Piyasası", slug: "/hizmetlerimiz/pay-piyasasi" },
      { label: "VİOP", slug: "/hizmetlerimiz/viop" },
      { label: "Borçlanma Araçları", slug: "/hizmetlerimiz/borclanma-araclari" },
      { label: "Halka Arz", slug: "/hizmetlerimiz/halka-arz" },
      { label: "Kurumsal Finansman", slug: "/hizmetlerimiz/kurumsal-finansman" },
      { label: "Yatırım Danışmanlığı", slug: "/hizmetlerimiz/yatirim-danismanligi" },
    ],
  },
  {
    label: "Yatırım Ürünleri",
    slug: "/yatirim-urunleri",
    children: [
      { label: "Hisse Senedi", slug: "/yatirim-urunleri/hisse-senedi" },
      { label: "VİOP Sözleşmeleri", slug: "/yatirim-urunleri/viop-sozlesmeleri" },
      { label: "Tahvil & Bono", slug: "/yatirim-urunleri/tahvil-bono" },
      { label: "Yatırım Fonları", slug: "/yatirim-urunleri/yatirim-fonlari" },
      { label: "Repo & Ters Repo", slug: "/yatirim-urunleri/repo" },
      { label: "Varant ve Sertifikalar", slug: "/yatirim-urunleri/varant" },
    ],
  },
  {
    label: "İletişim",
    slug: "/iletisim",
    children: null,
  },
];

export const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1920&q=80",
    title: "Youtube Kanalımıza Abone Olun.",
    description:
      "Acar Menkul Değerler Başanalisti Ahmet Mergen ile Borsa sohbetleri ve daha fazlası için bizi Youtube'ta ziyaret edebilirsiniz.",
    buttonLabel: "Detaylı Bilgi",
    buttonLink: "/iletisim",
    accent: "Youtube",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=1920&q=80",
    title: "Ücretsiz Günlük Bültenlerimiz ile Daima Yatırımcılarımızın Yanındayız",
    description:
      "Borsa, viop, dolar ve altın yatırımlarınız yapmadan önce bültenlerimize göz atmayı unutmayın!",
    buttonLabel: "Bizimle İletişime Geçin",
    buttonLink: "/iletisim",
    accent: "Bültenler",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=1920&q=80",
    title: "Önemli Bilgilendirme",
    description:
      "WhatsApp, Telegram gibi mesajlaşma uygulamaları ve sosyal medya üzerinden kendisini Acar Menkul Değerler olarak tanıtan kişilere itibar etmeyiniz.",
    buttonLabel: "Detaylı Bilgi",
    buttonLink: "/iletisim",
    accent: "Bilgilendirme",
  },
];

export const quickLinks = [
  { icon: "FileText", label: "KVKK", link: "/kisisel-verilerin-korunmasi" },
  { icon: "Globe", label: "Bilgi Toplum Hizmeti", link: "/bilgi-toplum-hizmeti" },
  { icon: "UserPlus", label: "Hesap Açmak İstiyorum", link: "/hakkimizda/bilgi-almak-istiyorum" },
  { icon: "AlertCircle", label: "Acil ve Beklenmedik Durum Planı", link: "/acil-durum-plani" },
];

export const announcements = [
  {
    id: 1,
    title: "2024 Yılı Olağan Genel Kurul Toplantısı Hakkında Duyuru",
    date: "15 Mart 2025",
    category: "Genel",
    excerpt:
      "Şirketimizin 2024 yılı olağan genel kurul toplantısı 28 Mart 2025 tarihinde gerçekleştirilecektir.",
  },
  {
    id: 2,
    title: "VİOP Teminat Oranları Güncellendi",
    date: "03 Mart 2025",
    category: "VİOP",
    excerpt:
      "Borsa İstanbul tarafından açıklanan yeni teminat oranları 04 Mart 2025 itibariyle geçerlidir.",
  },
  {
    id: 3,
    title: "Yeni Halka Arz Süreci Başladı",
    date: "21 Şubat 2025",
    category: "Halka Arz",
    excerpt:
      "XYZ A.Ş. halka arz talep toplama süreci 25-27 Şubat 2025 tarihleri arasında gerçekleştirilecektir.",
  },
  {
    id: 4,
    title: "Mobil Uygulamamız Güncellendi",
    date: "10 Şubat 2025",
    category: "Platform",
    excerpt:
      "Acar Trader mobil uygulaması yeni özellikleri ile birlikte güncellendi. Uygulama mağazalarından yeni sürümü indirebilirsiniz.",
  },
  {
    id: 5,
    title: "Bayram Tatili Çalışma Saatleri",
    date: "30 Ocak 2025",
    category: "Genel",
    excerpt:
      "Ramazan Bayramı tatili süresince müşteri hizmetlerimizin çalışma saatleri hakkında bilgi.",
  },
  {
    id: 6,
    title: "Temettü Ödeme Bilgilendirmesi",
    date: "18 Ocak 2025",
    category: "Temettü",
    excerpt:
      "BIST 30 şirketlerinin temettü ödeme tarihleri ve oranlarına dair detaylı bilgilendirme yayınlandı.",
  },
];

export const bulletins = [
  {
    id: 1,
    title: "Günlük Bülten - 18 Mayıs 2026",
    date: "18.05.2026",
    type: "Günlük",
    description: "BIST 100 endeksi günü %1.2 yükselişle kapattı. Bankacılık sektörü öne çıktı.",
  },
  {
    id: 2,
    title: "Günlük Bülten - 17 Mayıs 2026",
    date: "17.05.2026",
    type: "Günlük",
    description: "Piyasalar yatay seyrini sürdürürken USD/TRY paritesi 33.20 seviyesinde.",
  },
  {
    id: 3,
    title: "Haftalık Strateji Raporu",
    date: "16.05.2026",
    type: "Haftalık",
    description: "Bu hafta TCMB faiz kararı ve Fed tutanakları takip edilecek.",
  },
  {
    id: 4,
    title: "Aylık Makro Analiz",
    date: "01.05.2026",
    type: "Aylık",
    description: "Mayıs ayı makroekonomik göstergeler ve piyasa beklentilerine dair detaylı analiz.",
  },
  {
    id: 5,
    title: "VİOP Strateji Notu",
    date: "14.05.2026",
    type: "VİOP",
    description: "BIST 30 vadeli kontratlarında teknik seviyeler ve önerilen pozisyonlar.",
  },
  {
    id: 6,
    title: "Şirket Raporu: ASELS",
    date: "10.05.2026",
    type: "Şirket",
    description: "Aselsan 1Ç26 finansalları sonrası değerleme ve hedef fiyat güncellemesi.",
  },
];

export const trainings = [
  {
    id: 1,
    title: "Ahmet Mergen ile Piyasa Söyleşisi",
    instructor: "Ahmet Mergen",
    duration: "90 dk",
    level: "Tüm Seviyeler",
    description:
      "Başanalistimiz Ahmet Mergen ile haftalık piyasa değerlendirmeleri ve yatırım stratejileri.",
  },
  {
    id: 2,
    title: "Temel Analiz Eğitimi",
    instructor: "Acar Araştırma",
    duration: "6 saat",
    level: "Başlangıç",
    description: "Şirket bilançolarını okuma, oran analizleri ve değerleme yöntemleri.",
  },
  {
    id: 3,
    title: "Teknik Analiz Eğitimi",
    instructor: "Acar Araştırma",
    duration: "8 saat",
    level: "Orta",
    description:
      "Grafik okuma, formasyonlar, trend çizgileri ve teknik göstergelerin kullanımı.",
  },
  {
    id: 4,
    title: "VİOP Eğitimi",
    instructor: "Acar VİOP Masası",
    duration: "4 saat",
    level: "Orta - İleri",
    description: "Vadeli işlem sözleşmeleri, teminat, kaldıraç ve risk yönetimi.",
  },
  {
    id: 5,
    title: "Opsiyon Stratejileri",
    instructor: "Acar Türev Masası",
    duration: "5 saat",
    level: "İleri",
    description: "Opsiyon kontratları, Yunan harfler ve gelişmiş hedge stratejileri.",
  },
  {
    id: 6,
    title: "Portföy Yönetimi",
    instructor: "Acar Portföy",
    duration: "6 saat",
    level: "Orta",
    description: "Modern portföy teorisi, varlık dağılımı ve risk-getiri optimizasyonu.",
  },
];

export const services = [
  {
    icon: "TrendingUp",
    title: "Pay Piyasası",
    description: "Borsa İstanbul'da işlem gören hisse senetlerinde alım-satım hizmetleri.",
  },
  {
    icon: "BarChart3",
    title: "VİOP",
    description: "Vadeli İşlem ve Opsiyon Piyasası'nda uygun komisyon oranları ile işlem.",
  },
  {
    icon: "FileText",
    title: "Borçlanma Araçları",
    description: "Devlet tahvili, hazine bonosu ve özel sektör tahvilleri.",
  },
  {
    icon: "Briefcase",
    title: "Halka Arz",
    description: "Halka arzlarda aracılık hizmetleri ve danışmanlık.",
  },
  {
    icon: "Building2",
    title: "Kurumsal Finansman",
    description: "Şirketlere özel finansman çözümleri ve danışmanlık.",
  },
  {
    icon: "Users",
    title: "Yatırım Danışmanlığı",
    description: "Uzman kadromuzla bireysel yatırım danışmanlığı hizmeti.",
  },
];

export const products = [
  {
    title: "Hisse Senedi",
    description:
      "Borsa İstanbul'da işlem gören 500'den fazla hisse senedinde işlem yapma imkanı.",
    features: ["Pay Piyasası", "Yıldız Pazar", "Ana Pazar", "BIST Alt Pazarlar"],
  },
  {
    title: "VİOP Sözleşmeleri",
    description:
      "Endeks, hisse, döviz, kıymetli madenler ve emtia üzerine vadeli işlem sözleşmeleri.",
    features: ["BIST 30 Endeks", "USD/TRY", "Altın", "Hisse Vadelileri"],
  },
  {
    title: "Tahvil & Bono",
    description: "Devlet ve özel sektör borçlanma araçlarında alım-satım hizmetleri.",
    features: ["Devlet Tahvili", "Hazine Bonosu", "Özel Sektör Tahvili", "Eurobond"],
  },
  {
    title: "Yatırım Fonları",
    description: "Geniş fon yelpazemizle her yatırımcı profiline uygun çözümler.",
    features: ["Para Piyasası", "Hisse Senedi Fonları", "Karma Fonlar", "Serbest Fonlar"],
  },
];

export const platforms = [
  {
    title: "Acar Trader Web",
    description:
      "Tarayıcınız üzerinden işlem yapabileceğiniz, kurulum gerektirmeyen web tabanlı platform.",
    features: [
      "Anlık veri",
      "Gelişmiş grafik",
      "Çoklu pencere",
      "Hızlı emir iletimi",
    ],
    badge: "Web",
  },
  {
    title: "Acar Trader Mobil",
    description:
      "iOS ve Android cihazlarınız için tasarlanmış güçlü mobil işlem uygulaması.",
    features: [
      "Push bildirimleri",
      "Biometrik giriş",
      "Widget desteği",
      "Watchlist",
    ],
    badge: "Mobil",
  },
  {
    title: "Matriks IQ",
    description:
      "Profesyonel yatırımcılar için gelişmiş veri analizi ve işlem platformu.",
    features: [
      "Tier 1 veri",
      "Algoritmik işlem",
      "Tarama motoru",
      "Backtest",
    ],
    badge: "Pro",
  },
  {
    title: "İnternet Şubesi",
    description:
      "Hesap işlemleri, para transferi ve raporlama için güvenli internet şubesi.",
    features: [
      "Para transferi",
      "Raporlar",
      "Hesap özeti",
      "E-imza",
    ],
    badge: "Şube",
  },
];

export const boardMembers = [
  { name: "Mehmet Acar", title: "Yönetim Kurulu Başkanı" },
  { name: "Ayşe Acar", title: "Yönetim Kurulu Başkan Yardımcısı" },
  { name: "Ali Yılmaz", title: "Yönetim Kurulu Üyesi" },
  { name: "Fatma Demir", title: "Bağımsız Yönetim Kurulu Üyesi" },
  { name: "Hasan Kaya", title: "Genel Müdür" },
  { name: "Zeynep Çelik", title: "Genel Müdür Yardımcısı" },
];

export const branches = [
  {
    name: "Genel Müdürlük",
    address: "Büyükdere Cad. No: 123 Şişli / İstanbul",
    email: "info@acaronlinesube.com",
  },
  {
    name: "Ankara Şubesi",
    address: "Atatürk Bulvarı No: 45 Çankaya / Ankara",
    email: "info@acaronlinesube.com",
  },
  {
    name: "İzmir Şubesi",
    address: "Cumhuriyet Bulvarı No: 67 Konak / İzmir",
    email: "info@acaronlinesube.com",
  },
];
